import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import axios from "axios";

const HARDCODED = [
	{
		name: "Krystho Amara Pratama, S.Pd.",
		image: "",
		position: "Guru MTsN 1 Yogyakarta",
		deskripsi:
			"Platform Jogja Madrasah Digital ini sangat membantu, kami mempersiap digitalisasi madrasah ke depan. Cyber Madrasah dan Jogja Madrasah Digital merupakan solusi yang praktis dan relevan ditengah perkembangan teknologi, efisiensi, dalam pelaksanaan assesment digital dan peningkatan mutu pendidikan.",
	},
	{
		name: "Aldo Raisy Mahendra, S.Pd.",
		image: "",
		position: "Guru MAN 4 Bantul",
		deskripsi:
			"Kedatangan tim Jogja Madrasah Digital ini merupakan kesempatan besar untuk meningkatkan kualitas sistem manajemen di madrasah kami. Cybermadrasah sangat mudah untuk digunakan dan sangat membantu efisiensi kerja kami.",
	},
	{
		name: "Zahra Nabila Azzahra, S.Pd.",
		image: "",
		position: "Guru MIN 2 Sleman",
		deskripsi:
			"Saya sangat senang dengan kemudahan fitur presensi online. Orang tua juga bisa memantau kehadiran anak langsung. Platform ini benar-benar membuat proses administrasi menjadi lebih efisien.",
	},
];

function Testimoni() {
	const [isVisible, setIsVisible] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);
	const [testimonials, setTestimonials] = useState(HARDCODED);
	const [sectionTitle, setSectionTitle] = useState("Apa yang mereka katakan?");
	const sectionRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) setIsVisible(true);
			},
			{ threshold: 0.15 }
		);
		if (sectionRef.current) observer.observe(sectionRef.current);
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		axios
			.get("/api_w/testimonials", {
				headers: { db_name: process.env.REACT_APP_DB_NAME },
			})
			.then((res) => {
				const items = res.data.data;
				if (items?.length) {
					const mapped = items.map((t) => ({
						name: t.name,
						image: t.avatar_url || "",
						position: t.role || "",
						deskripsi: t.content,
					}));
					setTestimonials(mapped);
				}
			})
			.catch(() => {});
	}, []);

	return (
		<section aria-label="Testimoni"
			ref={sectionRef}
			className="py-24 px-4 md:px-20 bg-white overflow-hidden"
		>
			<div className="max-w-8xl mx-auto">
				<div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
					<div
						className={`w-full lg:w-5/12 transition-all duration-1000 ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-20 opacity-0"}`}
					>
						<div className="relative">
							<div className="aspect-[4/5] rounded-[3rem] overflow-hidden shadow-2xl relative z-10 border-8 border-white">
								<img
									src={
										testimonials[activeIndex]?.image ||
										"https://images.unsplash.com/photo-1541339907198-e08759df9a73?q=80&w=2070&auto=format&fit=crop"
									}
									alt={testimonials[activeIndex]?.name}
									className="w-full h-full object-cover"
									onError={(e) => { e.target.src = "https://placehold.co/400x500/006045/white?text=Testimoni"; e.target.onerror = null; }}
								/>
							</div>
							<div className="absolute -bottom-10 -right-10 w-full h-full bg-green-50 rounded-[3rem] -z-10 transform rotate-6" />
							<div className="absolute top-1/2 -left-10 w-24 h-24 bg-amber-100 rounded-full -z-10 blur-2xl opacity-60" />
						</div>
					</div>

					<div
						className={`w-full lg:w-7/12 transition-all duration-1000 delay-300 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-20 opacity-0"}`}
					>
						<h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
							{sectionTitle}
						</h2>
						<p className="text-green-600 font-medium mb-12">
							Tentang Jogja Madrasah Digital
						</p>

						<div className="relative">
							<Swiper
								slidesPerView={1}
								spaceBetween={30}
								autoplay={{ delay: 5000, disableOnInteraction: false }}
								onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
								pagination={{
									clickable: true,
									el: ".testimoni-custom-pagination",
								}}
								navigation={{
									nextEl: ".testimoni-next",
									prevEl: ".testimoni-prev",
								}}
								modules={[Pagination, Autoplay, Navigation]}
								className="testimonial-swiper"
							>
								{testimonials.map((testimonial, index) => (
									<SwiperSlide key={index}>
										<div className="py-4">
											<div className="text-green-600/20 mb-6">
												<svg
													className="w-20 h-20"
													fill="currentColor"
													viewBox="0 0 24 24"
												>
													<path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10H14.017zM0 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151C7.546 6.068 5.983 8.789 5.983 11H10v10H0z" />
												</svg>
											</div>
											<p className="text-xl md:text-2xl text-green-700 leading-relaxed font-medium mb-10 italic">
												"{testimonial.deskripsi}"
											</p>
											<div className="mt-8">
												<h3 className="text-lg font-bold text-gray-800">
													{testimonial.name}
												</h3>
												<p className="text-green-600 font-medium">
													{testimonial.position}
												</p>
											</div>
										</div>
									</SwiperSlide>
								))}
							</Swiper>

							<div className="flex items-center gap-6 mt-12">
								<div className="flex items-center gap-2">
									<button aria-label="Sebelumnya" className="testimoni-prev w-12 h-12 rounded-full border-2 border-green-100 flex items-center justify-center text-green-600 hover:bg-green-600 hover:text-white transition-all duration-300">
										<svg
											className="w-6 h-6"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth={2}
												d="M15 19l-7-7 7-7"
											/>
										</svg>
									</button>
									<button aria-label="Selanjutnya" className="testimoni-next w-12 h-12 rounded-full border-2 border-green-100 flex items-center justify-center text-green-600 hover:bg-green-600 hover:text-white transition-all duration-300">
										<svg
											className="w-6 h-6"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth={2}
												d="M9 5l7 7-7 7"
											/>
										</svg>
									</button>
								</div>
								<div className="testimoni-custom-pagination flex gap-2" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<style>{`
	.testimoni-custom-pagination .swiper-pagination-bullet {
	width: 8px; height: 8px; background: #d1d5db; opacity: 1; transition: all 0.3s ease; border-radius: 4px;
	}
	.testimoni-custom-pagination .swiper-pagination-bullet-active {
	width: 24px; background: #059669;
	}
	`}</style>
		</section>
	);
}

export default Testimoni;
